var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008014"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40840",
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 3,
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40841",
    d: "M1 16V28C1 29.6569 2.34315 31 4 31H16M8.89474 1H28C29.6569 1 31 2.34315 31 4V8.10526",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250695",
    d: "M11 8V0.5H21V8H11Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250697",
    d: "M24.9727 27.0514C24.9727 27.3275 25.1965 27.5514 25.4727 27.5514C25.7488 27.5514 25.9727 27.3275 25.9727 27.0514H24.9727ZM25.8262 18.0136C25.6309 17.8184 25.3144 17.8184 25.1191 18.0136L21.9371 21.1956C21.7419 21.3909 21.7419 21.7075 21.9371 21.9027C22.1324 22.098 22.449 22.098 22.6442 21.9027L25.4727 19.0743L28.3011 21.9027C28.4963 22.098 28.8129 22.098 29.0082 21.9027C29.2035 21.7075 29.2035 21.3909 29.0082 21.1956L25.8262 18.0136ZM25.9727 27.0514V18.3672H24.9727V27.0514H25.9727Z",
    fill: "#383434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/OrderIcon.991bd8fb73f9469f19e030068e729e0d.svg";
export { ForwardRef as ReactComponent };